import { Link } from "react-router-dom";
import { ArrowUpRight, Mail, Phone } from "lucide-react";
import { COMPANY, NAV_LINKS } from "@/data/content";
import { Logo } from "@/components/Navbar";

export default function Footer() {
  return (
    <footer className="noise relative bg-navy" data-testid="site-footer">
      <div className="hairline-gradient h-px w-full" />
      <div className="mx-auto w-full max-w-7xl px-6 py-16 lg:px-8 lg:py-20">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Logo />
            <p className="mt-6 max-w-sm text-[15px] leading-relaxed text-white/55" data-testid="footer-tagline">
              {COMPANY.tagline}
            </p>
            <p className="mt-4 inline-flex rounded-full border border-white/10 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.22em] text-aqua">
              Incorporated {COMPANY.incorporated}
            </p>
          </div>

          <div className="lg:col-span-3">
            <h3 className="text-xs font-bold uppercase tracking-[0.28em] text-white/40">Navigate</h3>
            <ul className="mt-6 space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    data-testid={`footer-link-${link.testId.replace("nav-link-", "")}`}
                    className="group inline-flex items-center gap-2 font-display text-[15px] font-semibold text-white/70 transition-colors hover:text-aqua"
                  >
                    {link.label}
                    <ArrowUpRight className="h-3.5 w-3.5 opacity-0 transition-opacity group-hover:opacity-100" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h3 className="text-xs font-bold uppercase tracking-[0.28em] text-white/40">Get in Touch</h3>
            <ul className="mt-6 space-y-4">
              <li>
                <a
                  href={`mailto:${COMPANY.email}`}
                  data-testid="footer-email"
                  className="group flex items-center gap-3 font-display text-[15px] font-semibold text-white/70 transition-colors hover:text-aqua"
                >
                  <span className="flex h-9 w-9 items-center justify-center rounded-lg border border-white/10 bg-white/5 text-aqua transition-colors group-hover:border-aqua/50">
                    <Mail className="h-4 w-4" />
                  </span>
                  {COMPANY.email}
                </a>
              </li>
              <li>
                <a
                  href={COMPANY.phoneHref}
                  data-testid="footer-phone"
                  className="group flex items-center gap-3 font-display text-[15px] font-semibold text-white/70 transition-colors hover:text-aqua"
                >
                  <span className="flex h-9 w-9 items-center justify-center rounded-lg border border-white/10 bg-white/5 text-aqua transition-colors group-hover:border-aqua/50">
                    <Phone className="h-4 w-4" />
                  </span>
                  {COMPANY.phoneDisplay}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center">
          <p className="text-xs tracking-wide text-white/40" data-testid="footer-copyright">
            © {new Date().getFullYear()} {COMPANY.legalName}. All rights reserved.
          </p>
          <p className="text-xs uppercase tracking-[0.24em] text-white/40">Securing the Digital Future</p>
        </div>
      </div>
    </footer>
  );
}
